import { render, staticRenderFns } from "./PatientClinic.vue?vue&type=template&id=3f415d0c"
import script from "./PatientClinic.vue?vue&type=script&lang=js"
export * from "./PatientClinic.vue?vue&type=script&lang=js"
import style0 from "./PatientClinic.vue?vue&type=style&index=0&id=3f415d0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports